import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';
const template = document.querySelector('template[data-gs-reward-return]');
if (template) {
  const { inspectRewardCart, refreshRewardDrawer, reconcileRewardProtection, orphanProtectionLines, acquireRewardCartLock, rewardRemovalNotice, isRewardRefresh, createRewardRefreshQueue } = await import(template.dataset.policyUrl);
  const { installRewardDrawerFocus } = await import(template.dataset.focusUrl);
  installRewardDrawerFocus(template.dataset);
  const onRewardPage = Boolean(document.querySelector('[data-gs-reward-page]'));
  let checking = false;
  let latestCart = null;
  let notice = sessionStorage.getItem('gs-reward-notice') || '';
  let uncertain = false;
  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('gs-reward-cart') : null;
  const active = () => sessionStorage.getItem('gs-reward-v2-started') === 'true';
  document.addEventListener('click',async event=>{
    const link=event.target.closest?.('[data-gs-reward-change]');
    if (!link) return;
    if (!onRewardPage) { sessionStorage.setItem('gs-reward-return-intent','change'); return; }
    event.preventDefault();
    await document.querySelector('#cart-drawer')?.close();
    document.dispatchEvent(new CustomEvent('gs:reward-continue',{detail:{intent:'change'}}));
  });
  const requestCart = async (suffix = '.js', options = {}) => {
    const response = await fetch(`${template.dataset.cartUrl}${suffix}`, {
      cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(20000),
      headers:{Accept:'application/json','Content-Type':'application/json'},...options,
    });
    if (!response.ok) throw new Error('Could not refresh reward cart');
    return response.json();
  };
  const broadcast = (cart, sections) => {
    const deferred=CartLinesUpdateEvent.createPromise();
    template.dispatchEvent(new CartLinesUpdateEvent({action:'change',context:'cart',lines:[],promise:deferred.promise}));
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{didError:false,itemCount:cart.item_count,items:cart.items,source:'reward-refresh',sections}});
  };
  const refresh = createRewardRefreshQueue(async (renderCart = false) => {
    if (onRewardPage || checking) return;
    checking=true;
    const release=await acquireRewardCartLock();
    let cleaning=false;
    try {
      let cart=await requestCart();
      const transition=rewardRemovalNotice(latestCart,cart,template.dataset.variant);
      if (transition) { notice=transition; document.dispatchEvent(new CustomEvent('gs:reward-removed',{detail:transition})); }
      if (active() && orphanProtectionLines(cart,template.dataset.variant).length) { cart=await reconcileRewardProtection(template.dataset.cartUrl,template.dataset.variant); renderCart=true; }
      let state=inspectRewardCart(cart,template.dataset.variant,'');
      if (state.rewards.length && !state.financiallyFree) {
        cleaning=true;
        cart=await requestCart('/update.js',{method:'POST',body:JSON.stringify({updates:Object.fromEntries(state.rewards.map(item=>[item.key,0]))})});
        cart=await reconcileRewardProtection(template.dataset.cartUrl,template.dataset.variant);
        if (inspectRewardCart(cart,template.dataset.variant,'').rewards.length) throw new Error('Reward removal not confirmed');
        notice=notice || 'removedSafety';
        renderCart=true;
      }
      if (inspectRewardCart(cart,template.dataset.variant,'').financiallyFree) notice='';
      latestCart=cart;
      uncertain=false;
      if (notice) sessionStorage.setItem('gs-reward-notice',notice);
      else sessionStorage.removeItem('gs-reward-notice');
      if (renderCart) broadcast(cart,await refreshRewardDrawer());
    } catch { uncertain=cleaning ? 'cleanup' : active() || Boolean(latestCart && inspectRewardCart(latestCart,template.dataset.variant,'').rewards.length); }
    finally {checking=false;release();}
  });
  channel?.addEventListener('message',event=>{
    if(event.data!=='cart-changed') return;
    if(onRewardPage) document.dispatchEvent(new Event('gs:reward-cart-refresh')); else refresh(true);
  });
  for(const name of [StandardEvents.cartLinesUpdate,StandardEvents.cartDiscountUpdate]) {
    document.addEventListener(name,event=>{
      if(event.target===template) return;
      event.promise?.then(result=>{
        if (isRewardRefresh(result?.detail)) return;
        channel?.postMessage('cart-changed');refresh();window.setTimeout(()=>refresh(),1200);
      }).catch(()=>{});
    });
  }
  document.addEventListener('gs:reward-view',event=>{
    latestCart=event.detail.cart;
    const intent=sessionStorage.getItem('gs-reward-return-intent');
    if (onRewardPage && intent) {
      sessionStorage.removeItem('gs-reward-return-intent');
      Promise.resolve(document.querySelector('#cart-drawer')?.close()).then(()=>
        document.dispatchEvent(new CustomEvent('gs:reward-continue',{detail:{intent}})));
    }
  });
  document.addEventListener('gs:reward-verified',()=>{channel?.postMessage('cart-changed');refresh(true);});
  window.addEventListener('pageshow',event=>{if(event.persisted) refresh(true);});
  window.addEventListener('focus',()=>refresh(true));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden) refresh(true);});
  refresh();
}
